import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { DateTimeRangePicker } from '@packages/components/date-pickers/date-time-range-picker/date-time-range-picker';
import { useDataExplorerConfiguration } from '@packages/hooks/use-data-explorer-configuration/use-data-explorer-configuration';

import { useFlowDataFilterParams } from '../../../hooks/use-flow-data-filter-params/use-flow-data-filter-params';

export const FlowDataDateRange = () => {
  const { t } = useTranslation('flow');

  const {
    dataExplorerConfiguration: { datePicker },
  } = useDataExplorerConfiguration();

  const { flowDataFilterParams, setFlowDataFilterParams } =
    useFlowDataFilterParams();

  return (
    <DateTimeRangePicker
      name="flowDateRange"
      value={flowDataFilterParams.dateRange}
      onChange={(dateRange) => setFlowDataFilterParams({ dateRange })}
      maxDateTime={dayjs().endOf('day')}
      minDateTime={dayjs().subtract(datePicker.maxRange, 'days').startOf('day')}
      shortcuts={datePicker.menuOptions}
      helperText={{
        start: t('ui:date.maximumRangeFromToday', {
          days: datePicker.maxRange,
        }),
      }}
      label={t('ui:date.dateRange')}
    />
  );
};
